import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';

export function crmErrorCode(error: unknown): string {
  const data = (
    error as { response?: { data?: { errorCode?: unknown; code?: unknown; message?: unknown } } }
  )?.response?.data;
  const value =
    data?.errorCode ??
    data?.code ??
    data?.message ??
    (error instanceof Error ? error.message : error);
  return typeof value === 'string' ? value : '';
}
export function crmErrorText(t: TFunction<'member'>, code: string) {
  return /^[A-Z][A-Z_]+$/.test(code)
    ? t(`crmErrors.${code}`, { defaultValue: t('crmErrors.unknown') })
    : t('crmErrors.unknown');
}
export function CrmErrorDetails({ code }: { code: string }) {
  const { t } = useTranslation('member');
  return code ? (
    <details className="mt-2 text-sm">
      <summary className="min-h-11 cursor-pointer">{t('crmErrors.details')}</summary>
      <pre className="whitespace-pre-wrap break-words">{code}</pre>
    </details>
  ) : null;
}
export function CrmError({ error }: { error: unknown }) {
  const { t } = useTranslation('member');
  const code = crmErrorCode(error);
  return (
    <>
      <span>{crmErrorText(t, code)}</span>
      <CrmErrorDetails code={code} />
    </>
  );
}
